<gc-modal
  [headerTitle]="
    'modal.' +
      (modalState() === modalStates.COMPLETED
        ? 'projectCompleted'
        : 'projectCompletion') | translate
  "
  [width]="'fullscreen'"
  (closeModal)="closeModal()"
  [primaryButtonText]="
    'modal.' +
      (modalState() === modalStates.COMPLETED ? 'ok' : 'completeProject')
      | translate
  "
  [secondaryButtonText]="
    modalState() === modalStates.COMPLETED
      ? undefined
      : ('modal.cancel' | translate)
  "
  [primaryButtonIsDisabled]="
    modalState() === modalStates.LOADING || !checkboxChecked
  "
  (primaryButtonClicked)="handleOnClickPrimaryButton()"
  (secondaryButtonClicked)="closeModal()"
>
  <div class="modal-content">
    @if (
      modalState() === modalStates.ACCEPT ||
      modalState() === modalStates.COMPLETED
    ) {
      <div class="project-info-wrapper">
        <gc-text [variant]="'minorHeading'">{{
          selectedProject()?.projectID
        }}</gc-text>
        <gc-text [variant]="'largeParagraph'">{{
          selectedProject()?.projectName
        }}</gc-text>
      </div>
    }
    @if (modalState() === modalStates.ACCEPT) {
      <div>
        <gc-text [variant]="'paragraph'" [truncate]="true">
          {{ 'modal.warningText.1' | translate }}
        </gc-text>

        <span>{{ ' ' }}</span>

        <gc-text
          [variant]="'bodyBold'"
          [textColor]="'critical'"
          [truncate]="true"
        >
          <u>
            {{ 'modal.warningText.2' | translate }}
          </u>
        </gc-text>

        <span>{{ ' ' }}</span>

        <gc-text [variant]="'paragraph'" [truncate]="true">
          {{ 'modal.warningText.3' | translate }}
        </gc-text>
      </div>

      <gc-checkbox
        [ariaLabel]="'confirm completion of project checkbox'"
        [checked]="checkboxChecked"
        [label]="'modal.confirmCheckboxLabel' | translate"
        (changed)="toggleCheckbox()"
      />
    }
    @if (modalState() === modalStates.LOADING) {
      <div class="loading-wrapper">
        <gc-loading-spinner [pixelSize]="64" />
        <gc-text [variant]="'subHeading'">{{
          'modal.loading' | translate
        }}</gc-text>
      </div>
    }
    @if (modalState() === modalStates.COMPLETED) {
      <gc-text [variant]="'paragraph'">{{
        'modal.completedInfo' | translate
      }}</gc-text>
    }
  </div>
</gc-modal>
